const TOKEN_KEY = 'usertoken'
const USERNAME = 'username'
const TOKEN_PDF = 'usertokenpdf'

const TokenService = {
    getToken(){
        return localStorage.getItem(TOKEN_KEY)
    },
    getUser(){
        return localStorage.getItem(USERNAME)
    },
    getTokenPDF(){
        return localStorage.getItem(TOKEN_PDF)
    }
}

export { TokenService }